module.exports = __webpack_public_path__ + "img/item_4.1f11a011.png";